import MiniBetslip from '~/components/betslip/components/mini-betslip';
import OddsFormatDropdown from '~/components/Header/lib/components/header/components/desktop-header/sub-components/odds-format-dropdown';
import StateDropdown from '~/components/Header/lib/components/header/components/state-dropdown';
import MiniMyOC from '~/components/myoddschecker/components/mini-myoc';
import { useLoaderContext } from '~/providers/loader-context';
import { useModalContext } from '~/providers/modal-context';
import { useMyOCContext } from '~/providers/myoc-context';
import { useServicesContext } from '~/providers/services-context';

import styles from './HeaderConfigItems.module.css';

const HeaderConfigItems = () => {
  const { countryCode, labelActions } = useServicesContext();
  const [{ showMyOC }] = useModalContext();
  const { myocData } = useMyOCContext();
  const loaderData = useLoaderContext();

  return (
    <div className={styles.itemsWrapper}>
			<OddsFormatDropdown />
			<StateDropdown />
			{showMyOC &&
      <MiniMyOC loaderData={loaderData} myocData={myocData} type="desktop" />
      }
			<div className={styles.hideOnMobile}>
				<MiniBetslip
          betslipTitle={labelActions.get('RESPONSIVE_BETSLIP')}
          countryCode={countryCode} />

			</div>
		</div>);

};

export { HeaderConfigItems };